export default "__VITE_ASSET__Cf6H92cJ__"